class RocketBlogList extends HTMLElement {
  constructor() {
    super()

		this.categories = this.querySelectorAll('.section-rocket-post-list__categories--title')
		this.posts = this.querySelectorAll('.section-rocket-post-list__categories--item')
  }

  connectedCallback() {
		this.handleChangeTabs()
  }

	handleChangeTabs() {
		if (this.categories.length > 0) {
			// Set active first tab
      let dataHandleActive
      this.categories[0].classList.add('active')
			dataHandleActive = this.categories[0].getAttribute('data-blog-handle')
			this.handleDisplayItem(dataHandleActive)

			this.categories.forEach(tab => {
        tab.addEventListener('click', () => {					
          this.categories.forEach(t => t.classList.remove('active'))
          tab.classList.add('active')
          if (tab.classList.contains('active')) {
            dataHandleActive = tab.getAttribute('data-blog-handle')
            this.handleDisplayItem(dataHandleActive)
          }
        })
      })
		}
	}

	handleDisplayItem(handleActive) {
		if (this.posts.length > 0) {
			this.posts.forEach(post => {
				let dataBlog = post.getAttribute('data-blog')
				if(handleActive === 'todos') {
					post.style.display = 'block'
				} else {
					if(dataBlog !== handleActive) {
						post.style.display = 'none'
					} else {
						post.style.display = 'block'
					}
				}
			})
		}
	}
}

customElements.define('rocket-blog-list', RocketBlogList);